"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9254],{

/***/ 42607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t2": function() { return /* binding */ PLACEHOLDER_COVER; },
  "ZP": function() { return /* binding */ cover_Cover; },
  "oH": function() { return /* binding */ makeImaginaryUrls; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(99951);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(48465);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(20597);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
;// CONCATENATED MODULE: ./components/cover/DraggableCover.tsx




var DraggableCover = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DraggableCover, Component);
    var _super = (0,_create_super/* default */.Z)(DraggableCover);
    function DraggableCover() {
        (0,_class_call_check/* default */.Z)(this, DraggableCover);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            y: 0,
            isDragging: false,
            startingX: null,
            startingY: null
        };
        _this.coverRef = /*#__PURE__*/ react.createRef();
        _this.parentRef = /*#__PURE__*/ react.createRef();
        _this.coverRect = null;
        _this.parentRect = null;
        _this.handleMouseDown = function(event) {
            var disabled = _this.props.disabled;
            if (disabled) {
                return;
            }
            _this.coverRect = _this.coverRef.current.getBoundingClientRect();
            _this.parentRect = _this.parentRef.current.getBoundingClientRect();
            var ref = _this.getCoordinates(event), x = ref.x, y = ref.y;
            _this.setState({
                startingX: x - (_this.coverRect.left - _this.parentRect.left),
                startingY: y - (_this.coverRect.top - _this.parentRect.top)
            });
            document.addEventListener("mouseup", _this.handleStopDragging);
            document.addEventListener("mousemove", _this.handleStartDragging);
        };
        _this.handleStartDragging = function(event) {
            var ref = _this.getCoordinates(event), x = ref.x, y = ref.y;
            var _state = _this.state, startingX = _state.startingX, startingY = _state.startingY;
            var a = Math.abs(Number(startingX) - x);
            var b = Math.abs(Number(startingY) - y);
            var distance = Math.round(Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2)));
            if (distance >= 10) {
                _this.handleStopDragging();
                _this.handleDrag();
            }
        };
        _this.handleStopDragging = function() {
            document.removeEventListener("mouseup", _this.handleStopDragging);
            document.removeEventListener("mousemove", _this.handleStartDragging);
        };
        _this.handleDrag = function() {
            _this.setState({
                isDragging: true
            });
            window.addEventListener("mouseup", _this.handleStopDrag);
            window.addEventListener("mousemove", _this.handleMouseMove);
        };
        _this.handleStopDrag = function() {
            _this.setState({
                startingY: null,
                isDragging: false
            });
            window.removeEventListener("mouseup", _this.handleStopDrag);
            window.removeEventListener("mousemove", _this.handleMouseMove);
        };
        _this.calculateCropState = function(y) {
            if (_this.coverRef.current && _this.parentRef.current) {
                return {
                    x: 0,
                    y: Math.abs(y),
                    original: {
                        width: _this.coverRef.current.naturalWidth,
                        height: _this.coverRef.current.naturalHeight
                    },
                    proportional: {
                        width: _this.parentRef.current.clientWidth,
                        height: Math.round(_this.coverRef.current.naturalHeight / _this.coverRef.current.naturalWidth * _this.parentRef.current.clientWidth)
                    },
                    rect: {
                        width: _this.parentRef.current.clientWidth,
                        height: _this.parentRef.current.clientHeight
                    }
                };
            } else {
                return null;
            }
        };
        _this.handleMouseMove = function(event) {
            var y = _this.getCoordinates(event).y;
            var onDragStop = _this.props.onDragStop;
            _this.setState(function(param) {
                var startingY = param.startingY;
                return {
                    y: _this.calculateY(y, Number(startingY))
                };
            }, function() {
                if (onDragStop) {
                    onDragStop(_this.calculateCropState(_this.state.y));
                }
            });
        };
        _this.calculateY = function(clientY, startingY) {
            var y = clientY - startingY;
            var y1 = Math.round(_this.parentRef.current.clientHeight);
            var y2 = Math.round(_this.coverRef.current.height);
            if (y >= 0) {
                return 0;
            } else if (y <= y1 - y2) {
                return y1 - y2;
            } else {
                return y;
            }
        };
        _this.getCoordinates = function(event) {
            var x, y;
            if ("ontouchstart" in window && event.touches) {
                x = event.touches[0].clientX;
                y = event.touches[0].clientY;
            } else {
                x = event.clientX;
                y = event.clientY;
            }
            return {
                x: x,
                y: y
            };
        };
        _this.getStyleForRender = function(y, disabled) {
            if (disabled) {
                return {
                    pointerEvents: "none",
                    userSelect: "none",
                    cursor: "default"
                };
            } else {
                return {
                    top: y,
                    userSelect: "none",
                    position: "absolute",
                    cursor: "row-resize"
                };
            }
        };
        return _this;
    }
    var _proto = DraggableCover.prototype;
    _proto.render = function render() {
        var _props = this.props, disabled = _props.disabled, children = _props.children;
        var _state = this.state, y = _state.y, isDragging = _state.isDragging;
        return children({
            top: y,
            isDragging: isDragging,
            coverRef: this.coverRef,
            parentRef: this.parentRef,
            events: {
                onMouseDown: this.handleMouseDown
            },
            style: this.getStyleForRender(y, disabled),
            cropState: this.calculateCropState(y)
        });
    };
    return DraggableCover;
}(react.Component);
DraggableCover.defaultProps = {
    onDragStop: null
};


// EXTERNAL MODULE: ./node_modules/.pnpm/react-progressive-image@0.6.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-progressive-image/dist.js
var dist = __webpack_require__(78135);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-powerplug@1.0.0_react@17.0.2/node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(41491);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/uniq.js
var uniq = __webpack_require__(37757);
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);
;// CONCATENATED MODULE: ./lib/utils/batchPreload.ts

function batchPreload(images) {
    if (typeof document !== "undefined" && document.images) {
        uniq_default()(images.filter(Boolean)).forEach(function(imageSrc) {
            if (imageSrc) {
                var image = new Image();
                image.src = imageSrc;
            }
        });
    }
    return [];
};

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/get.js
var get = __webpack_require__(48182);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
;// CONCATENATED MODULE: ./components/icons/CoverIcons.tsx




function RemoveIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 19 24",
        width: "1em",
        height: "1em"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M14.48 24H4.72C2.8 24 1.2 22.48 1.2 20.56V5.2c0-.24.16-.4.4-.4h16c.24 0 .4.16.4.4v15.36c0 1.92-1.6 3.44-3.52 3.44zM2 5.6v14.96C2 22 3.2 23.2 4.72 23.2h9.76c1.52 0 2.72-1.2 2.72-2.64V5.6H2z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M8 20.8c-.24 0-.4-.16-.4-.4v-12c0-.24.16-.4.4-.4.24 0 .4.16.4.4v12c0 .24-.16.4-.4.4zm3.2 0c-.24 0-.4-.16-.4-.4v-12c0-.24.16-.4.4-.4.24 0 .4.16.4.4v12c0 .24-.16.4-.4.4zm7.2-15.2H.8c-.24 0-.4-.16-.4-.4v-.8c0-1.52 1.28-2.8 2.8-2.8h2.24l.8-.8c.56-.56 1.28-.8 2-.8h2.8c.72 0 1.44.32 2 .8l.8.8H16c1.52 0 2.8 1.28 2.8 2.8v.8c0 .24-.16.4-.4.4zM1.2 4.8H18v-.4c0-1.12-.88-2-2-2h-2.4c-.08 0-.24-.08-.32-.08l-.88-.88c-.32-.4-.88-.64-1.36-.64h-2.8c-.56 0-1.04.24-1.44.56l-.88.88c-.08.08-.24.16-.32.16H3.2c-1.12 0-2 .88-2 2v.4zm3.6 16c-.24 0-.4-.16-.4-.4v-12c0-.24.16-.4.4-.4.24 0 .4.16.4.4v12c0 .24-.16.4-.4.4zm9.6 0c-.24 0-.4-.16-.4-.4v-12c0-.24.16-.4.4-.4.24 0 .4.16.4.4v12c0 .24-.16.4-.4.4z"
                })
            ]
        })
    }));
}
function RepositionIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 64 64",
        width: "1em",
        height: "1em"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "currentColor",
            d: "M0 44h31v16.586l-5.293-5.293-1.414 1.561 7 7.146h1.414l7-7.146-1.414-1.488L33 60.586V44h31v-2H0zM33 3.414l5.293 5.293 1.414-1.561-7-7.146h-1.414l-7 7.146 1.414 1.488L31 3.414V20H0v2h64v-2H33z"
        })
    }));
}
function CameraIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 24 20",
        width: "1em",
        height: "1em"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M21.5 20h-19A2.503 2.503 0 0 1 0 17.5v-13C0 3.122 1.122 2 2.5 2h3.789L7.971.163A.496.496 0 0 1 8.339 0h7.321a.5.5 0 0 1 .369.163L17.711 2H21.5C22.878 2 24 3.122 24 4.5v13c0 1.378-1.122 2.5-2.5 2.5zM2.5 3C1.673 3 1 3.673 1 4.5v13c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5v-13c0-.827-.673-1.5-1.5-1.5h-4.009a.5.5 0 0 1-.369-.163L15.44 1H8.56L6.878 2.837A.5.5 0 0 1 6.509 3H2.5zM12 17c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zm0-11c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
}

;// CONCATENATED MODULE: ./components/cover/Cover.tsx














var PLACEHOLDER_COVER = "https://static.govlaunch.com/covers/cover.png";
batchPreload([
    PLACEHOLDER_COVER
]);
var Cover = function(param) {
    var originalSource = param.originalSource, repositionedSource = param.repositionedSource, placeholderSource = param.placeholderSource, alt = param.alt, _readOnly = param.readOnly, readOnly = _readOnly === void 0 ? true : _readOnly, _width = param.width, width = _width === void 0 ? 1140 : _width, _height = param.height, height = _height === void 0 ? 245 : _height, onChange = param.onChange, onReposition = param.onReposition, onRemove = param.onRemove, containerProps = param.containerProps, imageProps = param.imageProps;
    batchPreload([
        originalSource,
        placeholderSource
    ]);
    if (!originalSource) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            css: {
                display: "flex",
                position: "relative",
                maxWidth: width,
                height: height
            }
        }, containerProps), {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", (0,_object_spread/* default */.Z)({
                    src: placeholderSource,
                    alt: alt,
                    css: {
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "top",
                        userSelect: "none"
                    }
                }, imageProps)),
                readOnly === false && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        bottom: 10,
                        right: 10,
                        position: "absolute",
                        pointerEvents: "all"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Filestack */.QZ, {
                        options: {
                            transformations: {
                                rotate: false,
                                circle: false,
                                crop: false
                            },
                            storeTo: {
                                location: "s3",
                                access: "public"
                            }
                        },
                        onSuccess: function(result) {
                            if (result.filesUploaded.length > 0) {
                                onChange(result.filesUploaded[0].url);
                            }
                        },
                        customRender: function(param) {
                            var onPick = param.onPick;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Button */.zx, {
                                onClick: onPick,
                                theme: "primary",
                                color: palette/* white */.ix,
                                textColor: palette/* innovatorBlue */.LD,
                                style: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CameraIcon, {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        ml: 7.5,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Edit Cover",
                                            id: "c56nZj"
                                        })
                                    })
                                ]
                            });
                        }
                    })
                })
            ]
        }));
    } else if (readOnly) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            css: {
                position: "relative",
                maxWidth: width,
                height: height
            }
        }, containerProps), {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", (0,_object_spread/* default */.Z)({
                src: repositionedSource || originalSource,
                alt: alt,
                css: {
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "top",
                    userSelect: "none"
                }
            }, imageProps))
        }));
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* State */.ZM, {
        initial: {
            isRepositioning: false,
            lastCropState: null
        },
        children: function(param) {
            var state = param.state, setState = param.setState;
            if (state.isRepositioning) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DraggableCover, {
                    disabled: false,
                    children: function(param) {
                        var parentRef = param.parentRef, coverRef = param.coverRef, events = param.events, style = param.style, cropState = param.cropState;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            ref: parentRef
                        }, containerProps), {
                            style: (0,_object_spread/* default */.Z)({
                                maxWidth: width,
                                height: height,
                                position: "relative",
                                overflow: "hidden"
                            }, get_default()("style", containerProps)),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, events), {
                                    ref: coverRef,
                                    src: originalSource,
                                    alt: alt,
                                    draggable: false,
                                    width: "100%"
                                }), imageProps), {
                                    style: (0,_object_spread/* default */.Z)({}, style, get_default()("style", imageProps))
                                })),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        display: "flex",
                                        flexDirection: "column",
                                        position: "absolute",
                                        top: 0,
                                        width: "100%",
                                        height: "100%",
                                        pointerEvents: "none"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: {
                                                width: "100%",
                                                height: 50,
                                                background: "rgba(33, 33, 33, 0.5)",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                color: "#ffffff",
                                                fontWeight: 500,
                                                fontSize: 14,
                                                textTransform: "uppercase"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Drag to Reposition",
                                                id: "IQ3n5u"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                bottom: 10,
                                                right: 10,
                                                display: "flex",
                                                position: "absolute",
                                                pointerEvents: "all"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                    mr: 10,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                        theme: "primary",
                                                        onClick: function() {
                                                            if (cropState === null) {
                                                                setState({
                                                                    isRepositioning: false,
                                                                    lastCropState: null
                                                                });
                                                                return;
                                                            }
                                                            onReposition(originalSource, cropState);
                                                            setState({
                                                                isRepositioning: false,
                                                                lastCropState: cropState
                                                            });
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "Save",
                                                            id: "jvo0vs"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                    theme: "primary",
                                                    color: palette/* white */.ix,
                                                    textColor: palette/* innovatorBlue */.LD,
                                                    onClick: function() {
                                                        setState({
                                                            isRepositioning: false
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Cancel",
                                                        id: "47FYwb"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }));
                    }
                });
            } else {
                var source, placeholder;
                if (repositionedSource) {
                    // if we have a `repositionedSource` we also have `originalSource`
                    source = repositionedSource;
                    placeholder = originalSource;
                } else if (originalSource) {
                    // if there's a `originalSource` we should have the placeholder as fallback
                    source = originalSource;
                    placeholder = placeholderSource;
                }
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* default */.Z, {
                    src: source,
                    placeholder: placeholder,
                    children: function(src, loading) {
                        var didCrop = state.lastCropState !== null;
                        if (loading) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                css: {
                                    position: "relative",
                                    overflow: "hidden",
                                    maxWidth: width,
                                    height: height
                                }
                            }, containerProps), {
                                children: [
                                    didCrop ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", (0,_object_spread/* default */.Z)({
                                        src: originalSource,
                                        alt: alt,
                                        css: {
                                            width: "100%",
                                            userSelect: "none",
                                            position: "absolute",
                                            top: state.lastCropState.y * -1
                                        }
                                    }, imageProps)) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", (0,_object_spread/* default */.Z)({
                                        src: src,
                                        alt: alt,
                                        css: {
                                            width: "100%",
                                            position: "absolute",
                                            top: 0,
                                            left: 0
                                        }
                                    }, imageProps)),
                                    didCrop && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            top: 0,
                                            display: "flex",
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                            pointerEvents: "none"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                width: "100%",
                                                height: 50,
                                                background: "rgba(33, 33, 33, 0.5)",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                color: "#ffffff",
                                                fontWeight: 500,
                                                fontSize: 14,
                                                textTransform: "uppercase"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* LoadingIndicator */.TF, {}),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                    ml: 7.5,
                                                    children: didCrop ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Saving",
                                                        id: "QLkzoS"
                                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Loading",
                                                        id: "iFsDVR"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }));
                        }
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            css: {
                                position: "relative",
                                maxWidth: width,
                                height: height
                            }
                        }, containerProps), {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", (0,_object_spread/* default */.Z)({
                                    src: src,
                                    alt: alt,
                                    css: {
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        objectPosition: "top",
                                        userSelect: "none"
                                    }
                                }, imageProps)),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        bottom: 10,
                                        right: 10,
                                        display: "flex",
                                        position: "absolute",
                                        pointerEvents: "all"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            display: "flex"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* SpacingBetween */.lv, {
                                            right: 10,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Button */.zx, {
                                                    theme: "primary",
                                                    color: palette/* white */.ix,
                                                    textColor: palette/* innovatorBlue */.LD,
                                                    onClick: function() {
                                                        setState({
                                                            isRepositioning: true
                                                        });
                                                    },
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RepositionIcon, {}),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                            ml: 7.5,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Reposition",
                                                                id: "olI5br"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Button */.zx, {
                                                    theme: "primary",
                                                    color: palette/* white */.ix,
                                                    textColor: palette/* orange */.$y,
                                                    onClick: onRemove,
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RemoveIcon, {}),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                            ml: 7.5,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Remove",
                                                                id: "G/yZLu"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }));
                    }
                });
            }
        }
    });
};
function makeImaginaryUrls(src, crop) {
    var imaginary = "https://imaginary-ssl.govlaunch.com";
    var rect = crop.rect, proportional = crop.proportional, x = crop.x, y = crop.y;
    var proportionalUrl = "".concat(imaginary, "/resize?width=").concat(proportional.width, "&height=").concat(proportional.height, "&url=").concat(src, "&force=true");
    var croppedUrl = [
        "".concat(imaginary, "/extract?"),
        "&areawidth=".concat(rect.width, "&areaheight=").concat(rect.height),
        "&top=".concat(y, "&left=").concat(x),
        "&url=".concat(encodeURIComponent(proportionalUrl)), 
    ].join("");
    return {
        original: src,
        proportional: proportionalUrl,
        cropped: croppedUrl
    };
}
/* harmony default export */ var cover_Cover = (Cover);


/***/ }),

/***/ 76198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mutations_SetProfileCover; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./lib/mutations/getTargetType.ts
var getTargetType = __webpack_require__(42293);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./lib/mutations/SetProfileCoverMutation.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SetProfileCover($targetType: ProfileCoverTarget!, $targetId: ObjectId!, $cover: CoverInput) {\n    setProfileCover(targetType: $targetType, targetId: $targetId, cover: $cover) {\n      __typename\n      ... on Government {\n        _id\n        cover {\n          ...CoverFragment\n        }\n      }\n      ... on GovernmentUser {\n        _id\n        cover {\n          ...CoverFragment\n        }\n      }\n      ... on VendorUser {\n        _id\n        cover {\n          ...CoverFragment\n        }\n      }\n      ... on PendingUser {\n        _id\n        cover {\n          ...CoverFragment\n        }\n      }\n      ... on Company {\n        _id\n        cover {\n          ...CoverFragment\n        }\n      }\n    }\n  }\n\n  fragment CoverFragment on Cover {\n    __typename\n    original\n    repositioned\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var SetProfileCoverMutation = ((0,lib/* gql */.Ps)(_templateObject()));

;// CONCATENATED MODULE: ./lib/mutations/SetProfileCover.tsx





var SetProfileCover = function(param) {
    var entityType = param.entityType, targetId = param.targetId, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: SetProfileCoverMutation,
        children: function(setProfileCover) {
            return children({
                onSetProfileCover: function(originalSource) {
                    setProfileCover({
                        variables: {
                            targetId: targetId,
                            targetType: (0,getTargetType/* default */.Z)(entityType),
                            cover: {
                                original: originalSource,
                                repositioned: null,
                                reposition: null
                            }
                        },
                        optimisticResponse: {
                            __typename: "Mutation",
                            setProfileCover: {
                                __typename: entityType,
                                _id: targetId,
                                cover: {
                                    __typename: "Cover",
                                    original: originalSource,
                                    repositioned: null
                                }
                            }
                        }
                    });
                },
                onSetRepositionedCover: function(originalSource, repositionedSource, repositionState) {
                    setProfileCover({
                        variables: {
                            targetId: targetId,
                            targetType: (0,getTargetType/* default */.Z)(entityType),
                            cover: {
                                original: originalSource,
                                repositioned: repositionedSource,
                                reposition: repositionState
                            }
                        },
                        optimisticResponse: {
                            __typename: "Mutation",
                            setProfileCover: {
                                __typename: entityType,
                                _id: targetId,
                                cover: {
                                    __typename: "Cover",
                                    original: originalSource,
                                    repositioned: repositionedSource
                                }
                            }
                        }
                    });
                },
                onRemoveCover: function() {
                    return setProfileCover({
                        variables: {
                            targetId: targetId,
                            targetType: (0,getTargetType/* default */.Z)(entityType),
                            cover: null
                        },
                        optimisticResponse: {
                            __typename: "Mutation",
                            setProfileCover: {
                                __typename: entityType,
                                _id: targetId,
                                cover: {
                                    __typename: "Cover",
                                    original: null,
                                    repositioned: null
                                }
                            }
                        }
                    });
                }
            });
        }
    });
};
/* harmony default export */ var mutations_SetProfileCover = (SetProfileCover);


/***/ })

}]);